<app-website-header></app-website-header>
<div class="container">
    <div class="row">
        <div class="col-md-12 mt-3 terms">
            
            <h2 style="color: #fff;background-color: #0D87C8;border-radius: 8px; padding: 5px;"><img src="assets/images/writing_1001371.svg" style="margin-left: 20px;width: 20px;height: 20px" />&nbsp;Terms and Conditions</h2>
        </div>
    </div>
    <div class="row" style="margin: 29px 0px;background-color: #f5f5f5;padding: 15px; border-radius: 10px;">
        <p [innerHTML]="content" style="text-align: justify;"></p>
    </div>
</div>
<app-website-footer></app-website-footer>